import React from 'react'
import './FooterInstagramLinks.scss'

type Props = {}

const FooterInstagramLinks = (props: Props) => {
    return (
        <div className="footer-instagram">
            <div className="footer-img">
                <img src="/images/footer-img-1.jpg" alt="" />
                <div className="footer-img-hover">
                    <img src="/images/instagram-img.png" alt="" />
                </div>
            </div>
            <div className="footer-img">
                <img src="/images/footer-img-2.jpg" alt="" />
                <div className="footer-img-hover">
                    <img src="/images/instagram-img.png" alt="" />
                </div>
            </div>
            <div className="footer-img">
                <img src="/images/footer-img-3.jpg" alt="" />
                <div className="footer-img-hover">
                    <img src="/images/instagram-img.png" alt="" />
                </div>
            </div>
            <div className="footer-img">
                <img src="/images/footer-img-4.jpg" alt="" />
                <div className="footer-img-hover">
                    <img src="/images/instagram-img.png" alt="" />
                </div>
            </div>
            <div className="footer-img">
                <img src="/images/footer-img-5.jpg" alt="" />
                <div className="footer-img-hover">
                    <img src="/images/instagram-img.png" alt="" />
                </div>
            </div>
            <div className="footer-img">
                <img src="/images/footer-img-6.jpg" alt="" />
                <div className="footer-img-hover">
                    <img src="/images/instagram-img.png" alt="" />
                </div>
            </div>
            <div className="footer-img last-footer-img">
                <img src="/images/footer-img-7.jpg" alt="" />
                <div className="footer-img-hover">
                    <img src="/images/instagram-img.png" alt="" />
                </div>
            </div>
        </div>
    )
}

export default FooterInstagramLinks
